var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/users/service") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/users/service",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,40.133 C42.484,36.292 33.979,34.111 24.96,34.111 C15.973,34.111 7.496,36.276 0,40.091 L0,58.043 L50,58.043 L50,40.133 Z",
    id: "Fill-1",
    fill: "#4064C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,22.0427 L14,22.0427 C12.896,22.0427 12,21.1467 12,20.0427 L12,17.0427 C12,15.9387 12.896,15.0427 14,15.0427 L36,15.0427 C37.104,15.0427 38,15.9387 38,17.0427 L38,20.0427 C38,21.1467 37.104,22.0427 36,22.0427",
    id: "Fill-3",
    fill: "#C29F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,26.4714 L17,26.4714 L17,35.2154 C18.886,37.5484 21.767,39.0424 25,39.0424 C28.233,39.0424 31.114,37.5484 33,35.2154 L33,26.4714 Z",
    id: "Fill-5",
    fill: "#C29F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.958,22.0427 C35.958,28.1177 31.033,33.0427 24.958,33.0427 C18.883,33.0427 14,28.1177 14,22.0427 L14,12.4427 C14,6.3677 18.883,1.4427 24.958,1.4427 C31.033,1.4427 35.958,6.3677 35.958,12.4427 L35.958,22.0427 Z",
    id: "Fill-7",
    fill: "#F0C6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,24.9255 L19,31.3455 C20.619,32.4655 22.694,33.1375 24.964,33.1375 C27.261,33.1375 29.364,32.4485 31,31.3045 L31,24.9255 C29.458,23.8455 27.415,23.0425 25,23.0425 C22.585,23.0425 20.417,23.8805 19,24.9255",
    id: "Fill-9",
    fill: "#7A6554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,11.0407 L14,18.9817 C14.351,19.0197 14.727,19.0427 15.143,19.0427 C22.75,19.0427 31.5,15.7097 35.998,11.0407 L14,11.0407 Z",
    id: "Fill-11",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,11.0417 C36,4.9437 31.057,-0.0003 24.958,-0.0003 C18.86,-0.0003 13.959,4.9417 13.959,11.0397 L13.958,11.0397 L13.958,11.0407 L13.958,11.0417 L13.96,11.0417 C15.004,12.5417 19.003,14.0427 25,14.0427 C30.997,14.0427 34.996,12.5417 35.998,11.0417 L36,11.0417 Z",
    id: "Fill-13",
    fill: "#4064C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.958,11.0398 C15,12.5398 19,14.0418 25,14.0418 C31,14.0418 35,12.5398 36,11.0398 L13.958,11.0398 Z",
    id: "Fill-15",
    fill: "#7992D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,14.0427 L37,14.0427",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.625,26.0559 C22.492,26.7809 23.642,27.3199 25,27.3199 C26.358,27.3199 27.578,26.7579 28.375,26.0559",
    id: "Stroke-19",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,35.5085 C42.37,34.9065 40.698,34.3935 39,33.9455 L39,47.0425 L11,47.0425 L11,33.9235 C9.302,34.3685 7.631,34.8805 6,35.4785 L6,58.0425 L44,58.0425 L44,35.5085 Z",
    id: "Fill-21",
    fill: "#7992D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,50.0427 C41,46.1767 37.866,43.0427 34,43.0427 C30.134,43.0427 27,46.1767 27,50.0427 C27,52.8337 28.637,55.2357 31,56.3597 L31,58.0427 L37,58.0427 L37,56.3597 C39.363,55.2357 41,52.8337 41,50.0427",
    id: "Fill-23",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,47.0427 C45,44.2517 43.363,41.8497 41,40.7257 L41,45.3137 L38.006,47.0427 L35.012,45.3137 L35.012,40.7197 C32.643,41.8417 31,44.2477 31,47.0427 C31,49.8337 32.637,52.2357 35,53.3597 L35,62.0427 L41,62.0427 L41,53.3597 C43.363,52.2357 45,49.8337 45,47.0427",
    id: "Fill-25",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,15.0427 C21,15.5947 20.553,16.0427 20,16.0427 C19.447,16.0427 19,15.5947 19,15.0427 C19,14.4907 19.447,14.0427 20,14.0427 C20.553,14.0427 21,14.4907 21,15.0427",
    id: "Fill-27",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,15.0427 C31,15.5947 30.553,16.0427 30,16.0427 C29.447,16.0427 29,15.5947 29,15.0427 C29,14.4907 29.447,14.0427 30,14.0427 C30.553,14.0427 31,14.4907 31,15.0427",
    id: "Fill-29",
    fill: "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.b192641db9f6d7fcfa4b0a0feaf34072.svg";
export { ForwardRef as ReactComponent };